import { createSelector } from 'reselect';

const getState = (state) => state.shipperOrderDocuments;

const isUploadDocumentsModalOpened = createSelector(
  getState,
  (state) => state.uploadDocumentsModalOpened
);

const getShipperOrderIdDocumentsModalOpened = createSelector(
  getState,
  (state) => state.shipperOrderId
);

export { isUploadDocumentsModalOpened, getShipperOrderIdDocumentsModalOpened };
